import {
  AIAssistPortletsActionTypes,
  AIAssistPortletsAction,
} from '../../actions/cbo/AIAssistPortletsAction';
import {
  IEpicDiagramResponse,
  IEpicsResponse,
  IUserStoriesForTestCasesResponse,
  IEpicsListResponse,
  IUserStoriesInBacklogBuildQAResponse,
  IUserStoriesShapeResponse,
  ITestCasesBuild,
  IDefectsBySprint,
  IDefectsByPriority,
  ITestCasesByStatusResponse,
  ISprintHealthResponse,
  ISprintBurnDownResponse,
  ISprintwiseCapacityResponse,
} from '../../../models/cbo/AIAssistPortletsModel';
import AIAssistPortletsState from '../../state/cbo/AIAssistPortletsState';

const initialState: AIAssistPortletsState = {
  epics: [],
  loading: false,
  error: null,
  epicsLoading: false,
  epicDiagram: {} as IEpicDiagramResponse,
  epicDiagramLoading: false,
  userStoriesForTestCases: [],
  userStoriesForTestCasesLoading: false,
  testCases: [],
  testCasesLoading: false,
  epicList: [],
  epicListLoading: false,
  userStoriesInBacklogBuildQA: [],
  userStoriesInBacklogBuildQALoading: false,
  userStoriesShape: [],
  userStoriesShapeLoading: false,
  testCasesBuild: [],
  testCasesBuildLoading: false,
  defectsBySprint: {} as IDefectsBySprint,
  defectsBySprintLoading: false,
  defectsByPriority: {} as IDefectsByPriority,
  defectsByPriorityLoading: false,
  testCasesByStatus: [],
  testCasesByStatusLoading: false,
  sprintHealth: {} as ISprintHealthResponse,
  sprintHealthLoading: false,
  sprintBurnDown: {} as ISprintBurnDownResponse,
  sprintBurnDownLoading: false,
  sprintwiseCapacity: [],
  sprintwiseCapacityLoading: false,
};

export const aiAssistPortletsReducer = (
  state = initialState,
  action: AIAssistPortletsAction,
): AIAssistPortletsState => {
  switch (action.type) {
    case AIAssistPortletsActionTypes.GET_EPICS_STARTED:
      return {
        ...state,
        epics: [],
        epicsLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_EPICS_SUCCESS:
      return {
        ...state,
        epicsLoading: false,
        epics: action.data as IEpicsResponse[],
      };
    case AIAssistPortletsActionTypes.GET_EPICS_ERROR:
      return {
        ...state,
        epicsLoading: false,
        error: action.data as string,
      };

    case AIAssistPortletsActionTypes.GET_EPIC_DIAGRAM_STARTED:
      return {
        ...state,
        epicDiagram: {} as IEpicDiagramResponse,
        epicDiagramLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_EPIC_DIAGRAM_SUCCESS:
      return {
        ...state,
        epicDiagramLoading: false,
        epicDiagram: action.data as IEpicDiagramResponse,
      };
    case AIAssistPortletsActionTypes.GET_EPIC_DIAGRAM_ERROR:
      return {
        ...state,
        epicDiagramLoading: false,
        error: action.data as string,
      };

    case AIAssistPortletsActionTypes.GET_USER_STORIES_FOR_TEST_CASES_STARTED:
      return {
        ...state,
        userStoriesForTestCases: [],
        userStoriesForTestCasesLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_USER_STORIES_FOR_TEST_CASES_SUCCESS:
      return {
        ...state,
        userStoriesForTestCasesLoading: false,
        userStoriesForTestCases: action.data as IUserStoriesForTestCasesResponse[],
      };
    case AIAssistPortletsActionTypes.GET_USER_STORIES_FOR_TEST_CASES_ERROR:
      return {
        ...state,
        userStoriesForTestCasesLoading: false,
        error: action.data as string,
      };

    case AIAssistPortletsActionTypes.GET_TEST_CASES_STARTED:
      return {
        ...state,
        testCases: [],
        testCasesLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_TEST_CASES_SUCCESS:
      return {
        ...state,
        testCasesLoading: false,
        testCases: action.data as IUserStoriesForTestCasesResponse[],
      };
    case AIAssistPortletsActionTypes.GET_TEST_CASES_ERROR:
      return {
        ...state,
        testCasesLoading: false,
        error: action.data as string,
      };

    case AIAssistPortletsActionTypes.GET_EPIC_LIST_STARTED:
      return {
        ...state,
        epicList: [],
        epicListLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_EPIC_LIST_SUCCESS:
      return {
        ...state,
        epicListLoading: false,
        epicList: action.data as IEpicsListResponse[],
      };
    case AIAssistPortletsActionTypes.GET_EPIC_LIST_ERROR:
      return {
        ...state,
        epicListLoading: false,
        error: action.data as string,
      };

    case AIAssistPortletsActionTypes.GET_USER_STORIES_BACKLOG_BUILD_QA_STARTED:
      return {
        ...state,
        userStoriesInBacklogBuildQA: [],
        userStoriesInBacklogBuildQALoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_USER_STORIES_BACKLOG_BUILD_QA_SUCCESS:
      return {
        ...state,
        userStoriesInBacklogBuildQA: action.data as IUserStoriesInBacklogBuildQAResponse[],
        userStoriesInBacklogBuildQALoading: false,
      };
    case AIAssistPortletsActionTypes.GET_USER_STORIES_BACKLOG_BUILD_QA_ERROR:
      return {
        ...state,
        userStoriesInBacklogBuildQALoading: false,
        error: action.data as string,
      };
    case AIAssistPortletsActionTypes.GET_USER_STORIES_SHAPE_STARTED:
      return {
        ...state,
        userStoriesShape: [],
        userStoriesShapeLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_USER_STORIES_SHAPE_SUCCESS:
      return {
        ...state,
        userStoriesShapeLoading: false,
        userStoriesShape: action.data as IUserStoriesShapeResponse[],
      };
    case AIAssistPortletsActionTypes.GET_USER_STORIES_SHAPE_ERROR:
      return {
        ...state,
        userStoriesShapeLoading: false,
        error: action.data as string,
      };
    case AIAssistPortletsActionTypes.GET_TEST_CASES_BUILD_STARTED:
      return {
        ...state,
        testCasesBuild: [],
        testCasesBuildLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_TEST_CASES_BUILD_SUCCESS:
      return {
        ...state,
        testCasesBuildLoading: false,
        testCasesBuild: action.data as ITestCasesBuild[],
      };
    case AIAssistPortletsActionTypes.GET_TEST_CASES_BUILD_ERROR:
      return {
        ...state,
        testCasesBuildLoading: false,
        error: action.data as string,
      };
    case AIAssistPortletsActionTypes.GET_DEFECTS_BY_SPRINT_STARTED:
      return {
        ...state,
        defectsBySprint: {} as IDefectsBySprint,
        defectsBySprintLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_DEFECTS_BY_SPRINT_SUCCESS:
      return {
        ...state,
        defectsBySprintLoading: false,
        defectsBySprint: action.data as IDefectsBySprint,
      };
    case AIAssistPortletsActionTypes.GET_DEFECTS_BY_SPRINT_ERROR:
      return {
        ...state,
        defectsBySprintLoading: false,
        error: action.data as string,
      };
    case AIAssistPortletsActionTypes.GET_DEFECTS_BY_PRIORITY_STARTED:
      return {
        ...state,
        defectsByPriority: {} as IDefectsByPriority,
        defectsByPriorityLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_DEFECTS_BY_PRIORITY_SUCCESS:
      return {
        ...state,
        defectsByPriorityLoading: false,
        defectsByPriority: action.data as IDefectsByPriority,
      };
    case AIAssistPortletsActionTypes.GET_DEFECTS_BY_PRIORITY_ERROR:
      return {
        ...state,
        defectsByPriorityLoading: false,
        error: action.data as string,
      };
    case AIAssistPortletsActionTypes.GET_TEST_CASES_BY_STATUS_STARTED:
      return {
        ...state,
        testCasesByStatus: [],
        testCasesByStatusLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_TEST_CASES_BY_STATUS_SUCCESS:
      return {
        ...state,
        testCasesByStatus: action.data as ITestCasesByStatusResponse[],
        testCasesByStatusLoading: false,
      };
    case AIAssistPortletsActionTypes.GET_TEST_CASES_BY_STATUS_ERROR:
      return {
        ...state,
        testCasesByStatusLoading: false,
        error: action.data as string,
      };
    case AIAssistPortletsActionTypes.GET_SPRINT_HEALTH_STARTED:
      return {
        ...state,
        sprintHealth: {} as ISprintHealthResponse,
        sprintHealthLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_SPRINT_HEALTH_SUCCESS:
      return {
        ...state,
        sprintHealthLoading: false,
        sprintHealth: action.data as ISprintHealthResponse,
      };
    case AIAssistPortletsActionTypes.GET_SPRINT_HEALTH_ERROR:
      return {
        ...state,
        sprintHealthLoading: false,
        error: action.data as string,
      };
    case AIAssistPortletsActionTypes.GET_SPRINT_BURNDOWN_STARTED:
      return {
        ...state,
        sprintBurnDown: {} as ISprintBurnDownResponse,
        sprintBurnDownLoading: true,
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_SPRINT_BURNDOWN_SUCCESS:
      return {
        ...state,
        sprintBurnDownLoading: false,
        sprintBurnDown: action.data as ISprintBurnDownResponse,
      };
    case AIAssistPortletsActionTypes.GET_SPRINT_BURNDOWN_ERROR:
      return {
        ...state,
        sprintBurnDownLoading: false,
        error: action.data as string,
      };
    case AIAssistPortletsActionTypes.GET_SPRINTWISE_CAPACITY_STARTED:
      return {
        ...state,
        sprintwiseCapacityLoading: true,
        sprintwiseCapacity: [],
        error: null,
      };
    case AIAssistPortletsActionTypes.GET_SPRINTWISE_CAPACITY_SUCCESS:
      return {
        ...state,
        sprintwiseCapacityLoading: false,
        sprintwiseCapacity: action.data as ISprintwiseCapacityResponse[],
      };
    case AIAssistPortletsActionTypes.GET_SPRINTWISE_CAPACITY_ERROR:
      return {
        ...state,
        sprintwiseCapacityLoading: false,
        error: action.data as string,
      };
    default:
      return state;
  }
};
